import { bvaAPI } from 'api'
import { BrandApiResponse } from 'model/BrandApiResponse'
import { BrandList } from 'model/BrandList'

interface FetchBrandsParams {
  page?: number
  limit?: number
  includeDraft?: boolean
  searchTerm?: string
  sortedBy?: string
  version?: string
}

export const fetchBrands = (data: any, page = 1) =>
  bvaAPI.get<{ data: BrandList }>('/brands', {
    params: {
      ...data,
      page,
    },
  })

export const fetchBrandsSearch = async (params: FetchBrandsParams, signal?: AbortSignal): Promise<BrandApiResponse> => {
  const producer = bvaAPI.get<BrandApiResponse>('/BVA', {
    params: {
      page: params.page ?? 1,
      limit: params.limit ?? 10,
      includeDraft: params.includeDraft ?? false,
      ...(params.searchTerm && { searchTerm: params.searchTerm }),
      ...(params.sortedBy !== 'Recent' && { sortedBy: params.sortedBy }),
      ...(params.version && params.version !== 'ALL' && { version: params.version }),
    },
  })

  const response = await producer(signal)

  return response.data
}
